import { isString, memoize } from 'lodash-es';
import { marked } from 'marked';

function markdown(input: string): string {
  return isString(input) ? marked.parseInline(input) : '';
}

export const md = memoize(markdown);
